"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flip;
var _reactDom = require("@floating-ui/react-dom");
function flip() {
  return (0, _reactDom.flip)();
}